import React, { useRef, useState } from "react";
import styles from "./Dropdown.module.scss";
import ChevronIcon from "components/svgs/ChevronIcon";
import { useClickOutside } from "hooks/useClickOutside";

const Dropdown = ({ placeholder, options, selectedValue, handleChange }) => {
  const dropdownRef = useRef(null);
  const [showOptions, setShowOptions] = useState(false);
  const [searchValue, setSearchValue] = useState("");

  useClickOutside(dropdownRef, () => {
    setShowOptions(false);
  });

  return (
    <div
      className={`${styles.dropdownContainer} ${
        showOptions ? styles.open : ""
      }`}
      ref={dropdownRef}
    >
      <div
        className={styles.dropdown}
        onClick={() => setShowOptions(!showOptions)}
      >
        <span>{selectedValue ? selectedValue.label : placeholder}</span>
        <ChevronIcon />
      </div>
      {showOptions ? (
        <ul className={styles.options}>
          <li className={styles.search}>
            <input
              type="text"
              placeholder="Search..."
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
            />
          </li>
          {options
            .filter((option) =>
              option.label.toLowerCase().includes(searchValue.toLowerCase())
            )
            .map((option) => {
              return (
                <li
                  key={option.key}
                  onClick={() => {
                    handleChange(option);
                    setShowOptions(false);
                  }}
                  className={
                    selectedValue.key === option.key ? styles.selected : ""
                  }
                >
                  {option.label}
                </li>
              );
            })}
        </ul>
      ) : null}
    </div>
  );
};

export default Dropdown;
